<template>
  <v-icon>
    {{ svgPath }}
  </v-icon>
</template>

<script>
import { mdiAlertOctagonOutline } from "@mdi/js";
export default {
  name: "MdiAlertOctagonOutline",
  data() {
    return {
      svgPath: mdiAlertOctagonOutline,
    };
  },
};
</script>
